import { AxiosError } from 'axios';
import * as Sentry from '@sentry/browser';

function LogErrorMessage(customMessage: string, e: AxiosError): void {
  let errorMessage: string;
  if (e.response) {
    errorMessage = `${e.response.status} - ${e.response.data}`;
  } else if (e.request) {
    errorMessage = e.request;
  } else {
    errorMessage = e.message;
  }
  Sentry.captureMessage(customMessage + errorMessage);
}

export default LogErrorMessage;
